import { Component, Input } from '@angular/core';

import { ModalTypeComponent } from '../modal-type.shared.component';

@Component({
    selector: 'shared-modal-type-popup',
    templateUrl: './modal-type-popup.shared.component.html',
    styleUrls: ['./modal-type-popup.shared.component.scss']
})
export class ModalTypePopupComponent extends ModalTypeComponent {
    @Input() public btnCloseSize: OLO.Components.BUTTON_SIZE = 'xlg';
}
